import { useIntl } from "@components/Intl"
import { Label, Paragraph } from "@components/Typography"
import { ChoicesArticle, ChoicesComponentFilter } from "@generated"
import formatPrice from "@lib/formatPrice"
import { motion } from "framer-motion"
import React from "react"
import * as S from "./elements"

interface Props {
  tab: ChoicesComponentFilter
  activeItem: ChoicesArticle
}

const ArticleInfo: React.FC<Props> = ({ tab, activeItem }) => {
  const { messages } = useIntl()
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      key={activeItem.id}
    >
      <S.Container display={["none", "none", "block"]}>
        <S.ActiveComponent>
          {messages.configurator[tab.toLowerCase()] || null}
        </S.ActiveComponent>
        <S.Title>{activeItem.name}</S.Title>
        <Label>{activeItem.price && formatPrice(activeItem.price)}</Label>
      </S.Container>
      <S.Container
        display={["flex", "flex", "none"]}
        position="absolute"
        bottom="0"
        justifyContent="center"
      >
        <Paragraph color="text.light" style={{ fontSize: 14 }}>
          {activeItem.name}
          <span>•</span>
          {activeItem.price && formatPrice(activeItem.price)}
        </Paragraph>
      </S.Container>
    </motion.div>
  )
}

export default ArticleInfo
